import { IInspirationHeaderBlock } from '@features/cms/typescript/index';
import styles from '@features/cms/components/inspirations/InspirationHeaderBlock/InspirationHeaderBlock.styles';
import Heading from '@components/Heading/Heading';
import sanitizeHtml from '@utils/sanitizeHtml';
import theme from '@styles/theme';
type PropsType = {
  data: IInspirationHeaderBlock;
  defaultBackground?: string;
  isFirst?: boolean;
};
const InspirationHeaderBlock = ({
  data,
  defaultBackground = theme.rawColors.beige300,
  isFirst = false
}: PropsType) => <section id={data.code} sx={styles.styledSection(data.background || defaultBackground)} data-testid={data.code}>
    <div sx={styles.contentHolder(data.bottomPosition === '' ? '0.5' : data.bottomPosition)} data-testid="inspiration-header-block-content-holder">
      <div sx={styles.fixedHeader} data-testid="inspiration-header-block-fixed-header">
        <Heading h={isFirst ? 1 : 2} addSx={styles.styledHeading} color={data.titleColor}>
          <span sx={styles.styledMainHeading} dangerouslySetInnerHTML={sanitizeHtml(data?.title)} />{' '}
          {data.subtitle && <span sx={styles.styledSubtitleHeading}>{data.subtitle.toLowerCase()}</span>}
        </Heading>
      </div>
    </div>
  </section>;
export default InspirationHeaderBlock;